import { computed, type ComputedRef, type Ref, ref } from 'vue'

export type DeliveryOrder = {
  id: number
  deliveredAt: string | null
  esign: boolean
}

export function useDeliveredAtField(deliveryOrder: DeliveryOrder | null = null) {
  const deliveryOrderRef: Ref<DeliveryOrder | null> = ref(deliveryOrder)

  const mandatory: ComputedRef<boolean> = computed(() => deliveryOrderRef.value?.esign === true)

  return {
    mandatory,
  }
}
